module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-history-panel"
  }, [_c('div', {}, [_c('div', {
    staticClass: "revision-history-panel__revisions"
  }, [_c('oval-label', {
    staticClass: "revision-history-panel__revisions-circle"
  }, [_vm._v("\n        Revisions\n      ")]), _vm._v(" "), _c('oval-label', {
    staticClass: "revision-history-panel__clear",
    nativeOn: {
      "click": function($event) {
        return _vm.clearRevisionHistory.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        CLEAR\n      ")])], 1), _vm._v(" "), _c('scroll-panel', {
    staticClass: "revision-history-panel__scroll-header",
    attrs: {
      "height": _vm.heightOfRevisions
    }
  }, _vm._l((_vm.revisionHistories), function(rh) {
    return _c('revision-history', _vm._b({
      key: rh.id,
      class: {
        'revision-history-panel__revision': true,
        'revision-history-panel__current-move': rh.id === _vm.selectedRevision
      },
      attrs: {
        "currentAudience": _vm.currentAudience,
        "isCurrentRevision": rh.id === _vm.selectedRevision,
        "goto": function () { return _vm.onClickRevisionHistory(rh); }
      }
    }, 'revision-history', rh, false))
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "revision-history-panel__dividor"
  }, [_c('oval-label', {
    staticClass: "revision-history-panel__branch-header"
  }, [_vm._v("\n      Versions\n    ")]), _vm._v(" "), _c('positive-circle', {
    staticClass: "revision-history-panel__add-branch",
    attrs: {
      "size": 21
    },
    nativeOn: {
      "click": function($event) {
        return _vm.createNewBranch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.currentBranchLabel) + "\n    ")]), _vm._v(" "), _c('scroll-panel', {
    staticClass: "revision-history-panel__scroll-header",
    attrs: {
      "height": _vm.heightOfBranches
    }
  }, [_vm._l((_vm.branches), function(b) {
    return [(b.id !== _vm.selectedBranch) ? _c('branch', _vm._b({
      key: b.id,
      class: {
        'revision-history-panel__branch': true,
        'revision-history-panel__current-branch': b.id === _vm.selectedBranch
      },
      attrs: {
        "goto": function () { return _vm.onClickBranch(b); },
        "currentAudience": _vm.currentAudience,
        "isCurrentBranch": b.id === _vm.selectedBranch,
        "deleteBranch": function () { return _vm.deleteBranch(b); }
      }
    }, 'branch', b, false)) : _vm._e()]
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23dbfbec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/revisionHistory/RevisionHistoryPanel.vue
// module id = 1841
// module chunks = 0